import { APIProvider, InfoWindow, Map, Marker, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useRef, useState } from "react"
import Button from "../../../../components/button/button";
import NotificationsService from "../../../../services/web/notification-service";

const InitMap = ({ id, markers, openGis }) => {
    const markerRef = useRef([]);
    const [markerSelected, setMarkerSelected] = useState(null);

    const map = useMap();
    const coreLib = useMapsLibrary("core");

    useEffect(() => {
        if (!map || !coreLib) return;

        if (markers.length > 1) {
            const bounds = new coreLib.LatLngBounds();
            markers.forEach(m => bounds.extend({ lat: Number(m.lat), lng: Number(m.lng) }));
            map.fitBounds(bounds);
        } else {
            map.setCenter({ lat: Number(markers[0].lat), lng: Number(markers[0].lng) });
        };

        return () => setMarkerSelected(null);
    }, [map, markers, coreLib]);

    const setMarkerRef = (marker) => {
        if (!marker) return;
        markerRef.current[marker.id] = marker;
    };

    const onClick = (marker) => {
        if (!marker.description) return;
        setMarkerSelected(prev => prev !== marker.id ? marker.id : null);
    };

    return (
        <Map
            reuseMaps={true}
            defaultZoom={16}
            streetViewControl={false}
            defaultCenter={{ lat: 0, lng: 0 }}
            gestureHandling={"cooperative"}
            zoomControl={false}
            disableDefaultUI={true}
            style={{ height: "100%" }}
        >
            { markers.map((marker, i) => {
                marker.id = "marker-" + id + "-" + i;

                return (
                    <Marker 
                        id={marker.id}
                        key={marker.id}
                        label={!!marker?.marker ? { text: marker.marker, color: "#fff" } : null}
                        onClick={() => onClick(marker)}
                        description={marker?.description ?? ""}
                        position={{ lat: parseFloat(marker.lat), lng: parseFloat(marker.lng) }}
                        lat={marker.lat}
                        lng={marker.lng}
                        ref={setMarkerRef}
                    />
                )
            }) }
            { 
                !!markerSelected && !!markerRef.current[markerSelected] && 
                <InfoWindow anchor={markerRef.current[markerSelected]} onCloseClick={() => setMarkerSelected(undefined)}>
                    <div className="flex flex-col gap-2">
                        { markerRef.current[markerSelected].description }

                        {
                            markers.length > 1 &&
                            <Button 
                                target="primary-outline"
                                className={"w-[42px]"}
                                title="Abrir mapa em tempo real" 
                                onClick={() => openGis(markerRef.current[markerSelected])}
                            >
                                <img src={NotificationsService.gisIcon} alt="gis-icon" />
                            </Button>
                        }
                    </div>
                </InfoWindow>
            }
        </Map>
    )
};

const NotificationMap = ({ id, markers, title, apiKey, name }) => {
    const openGis = (marker) => {
        const { lat, lng } = marker;
        window.open(NotificationsService.gisUrl({ lat, lng, title }));
    };

    return (
    <>
        <div className="mb-1 flex items-center justify-start gap-5">
            <h3 className="text-lg! font-semibold">{name}</h3>
            { markers?.length === 1 && (
                <Button
                    target="primary-outline"
                    title="Abrir mapa em tempo real"
                    onClick={() => openGis(markers[0])}
                >
                    <img src={NotificationsService.gisIcon} alt="gis-icon" />
                </Button>
            ) }
        </div>
        <div className="w-full h-70 relative overflow-hidden">
            <div className="absolute inset-0 pb-12">
                <APIProvider apiKey={apiKey}>
                    <InitMap id={id} markers={markers} openGis={openGis} />
                </APIProvider>
            </div>
        </div>
    </>
    )
};

export default NotificationMap;